/* global $ _ TweenMax lng Quint Quart TimelineMax Power0 Power1 Power2 Hammer ga Linear Shopify geoplugin_city */
'use strict';
var WbshckWeb = (function($,_,tw) {

    // vars
    var ww = $(window).width(),
        wh = $(window).height(),
        $root = $('.UIRoot'),
        touch = false,
        cookiesSettings, cookiesDefault;

    // init
    (function() {

        // browser type
        $('body').addClass($.browser.name);
        $('body').addClass($.browser.platform);
        touch = isTouchDevice();

        // controllers
        globalController();
        headerController();
        if ($('.UIHome').length > 0) homeController();
        if ($('.UIProduct').length > 0) productController();
        if ($('.UICollection').length > 0) collectionController();
        if ($('.UIAccount').length > 0) accountController();
        if ($('.UIAccount.addresses').length > 0) addressesController();
        if ($('.UIContact').length > 0) contactController();
        if ($('.UICart').length > 0) cartController();

        function globalController() {

            (function() {
                geolocation();
                input();
                events();
            }());

            function events() {

                // hide alert bar if user manually selects currency
                $('.alert-bar a.dismiss').off('click').on('click',function(e) {
                    if (typeof(Storage) !== 'undefined') {
                        localStorage.setItem('displayAlertBar', false);
                        $('.alert-bar').remove();
                    }
                });

                // hide notif bar if user manually selects currency
                $('.UIHeader .currency .selector a').off('click.wbshck.notif').on('click.wbshck.notif',function(e) {
                    if (typeof(Storage) !== 'undefined') {
                        localStorage.setItem('displayCurrencyNotification', false);
                    }
                });

                // remove currencyNotification
                $('.wbshck .currencyNotification .ok').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    $('.wbshck .currencyNotification').remove();
                    if (typeof(Storage) !== 'undefined') {
                        localStorage.setItem('displayCurrencyNotification', false);
                    }
                });

                // disable blind DEV links
                $root.find('a[href="/"]').click(function(e) {
                    // e && e.preventDefault();
                });

                // resize
                $(window).resize(function() {
                    ww = $(window).width();
                    wh = $(window).height();
                });

            }

            function input() {

                // scroll to anchor
                setTimeout(function() {
                    (window.location.hash) && scrollToAnchor(window.location.hash);
                },1000);

                // alert bar notification
                if (typeof(Storage) !== 'undefined') {
                    // show alert bar
                    if (localStorage.getItem('displayAlertBar') != 'false') {
                        displayAlertBar();
                    }
                    // diable alert bar localstorage if no alert bar present in the html
                    if ($('.alert-bar').length < 1) {
                        localStorage.removeItem('displayAlertBar');
                    }
                }

                // currency notification
                if (typeof(Storage) !== 'undefined') {
                    if (localStorage.getItem('displayCurrencyNotification') == 'true') {
                        displayCurrencyNotification();
                    }
                }

            }

            function displayAlertBar() {
                $('.alert-bar').show();
            }

            function displayCurrencyNotification() {

                var currency = $('.UIHeader .currency').data('currency'),
                    $notifcation;

                if (typeof(Storage) !== 'undefined') {
                    currency = localStorage.getItem('geolocalCurrency');
                }

                $notifcation = $('<div class="currencyNotification"><b>We\'ve noticed that your local currency is '+ currency +', so '+ currency +' pricing will be displayed. You can change the selected currency in the main menu.</b> <a href="#" class="btn ok">OK!</a></div>');

                $('.wbshck .UIRoot').append($notifcation);

                events();
            }

            function geolocation() {

                var maxTry = 15,
                    tryStep = 0,
                    supportedCurrencies = [],
                    cartCurrency = $('.UIHeader .currency').data('currency'),
                    _stopAsking = getStopAsking();


                $('.UIHeader .currency .selector a b').each(function() {
                    supportedCurrencies.push($(this).text());
                });

                // console.log(supportedCurrencies, cartCurrency);
                if (supportedCurrencies.length < 1) return;

                clearGeolocationInterval();
                window.geolocationInterval = setInterval(function() {
                    checkForGeolocationData();
                    tryStep++;
                    if (tryStep > maxTry) clearGeolocationInterval();
                },1000);

                function checkForGeolocationData() {
                    var geolocalCurrency;
                    // console.log('checking('+tryStep+'):', $('.locale-bar__container').length);
                    if ($('.locale-bar__container').length > 0) {
                        geolocalCurrency = $('.locale-bar__container input[name="currency_code"]').val();
                        // console.log('stopAsking:'+_stopAsking);
                        if (
                            supportedCurrencies.indexOf(geolocalCurrency)!=-1 &&
                            cartCurrency != geolocalCurrency &&
                            _stopAsking != 'true'
                        ) {
                            // if (confirm('It looks like your local currency is '+geolocalCurrency+'.\nWould you like to switch to this currency?')) {
                            window.location.href='?currency='+geolocalCurrency;
                            // }
                            // stopAsking();
                            stopAskingAndDisplayTheNtification(geolocalCurrency);
                        }
                        // console.log('geolocalCurrency:'+geolocalCurrency);
                        clearGeolocationInterval();
                    }
                }

                function getStopAsking() {
                    if (typeof(Storage) !== 'undefined') {
                        return localStorage.getItem('stopAsking');
                    }
                    else {
                        return false;
                    }
                }

                function stopAsking() {
                    if (typeof(Storage) !== 'undefined') {
                        localStorage.setItem('stopAsking', true);
                    }
                }

                function stopAskingAndDisplayTheNtification(geolocalCurrency) {
                    if (typeof(Storage) !== 'undefined') {
                        localStorage.setItem('stopAsking', true);
                        localStorage.setItem('displayCurrencyNotification', true);
                        localStorage.setItem('geolocalCurrency', geolocalCurrency);
                    }
                }

                function clearGeolocationInterval() {
                    (window.geolocationInterval) && (clearInterval(window.geolocationInterval));
                }

            }
        }

        function headerController() {

            var moveSubmenuNodeTO,
                wwscr;

            (function() {
                events();
            }());

            function events() {

                // currency
                $('.UIHeader .currency .close').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    hideSubmenu();
                    $('.UIHeader .currency .selected').removeClass('active');
                    $('.UIHeader .currency .selector').removeClass('active');
                });
                $('.UIHeader .currency .selected').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    hideSubmenu();
                    $('.UIHeader .currency .selected').toggleClass('active');
                    $('.UIHeader .currency .selector').toggleClass('active');
                });

                // prevent click
                $('.UIHeader .menu a.has-submenu').off('click.wbshck').on('click.wbshck',function(e) {
                    if (touch || $(window).width() <= 1023) {
                        e && e.preventDefault();
                        $('.UIHeader .currency .selected').removeClass('active');
                        $('.UIHeader .currency .selector').removeClass('active');
                        if (!$(this).hasClass('active')) {
                            hideSubmenu();
                            showSubmenu($(this));
                        }
                        else {
                            hideSubmenu();
                        }
                    }
                });


                // currency
                $('.UIHeader .country .close').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    hideSubmenu();
                    $('.UIHeader .country .selected').removeClass('active');
                    $('.UIHeader .country .selector').removeClass('active');
                });
                $('.UIHeader .country .selected').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    hideSubmenu();
                    $('.UIHeader .country .selected').toggleClass('active');
                    $('.UIHeader .country .selector').toggleClass('active');
                });

                // prevent click
                $('.UIHeader .menu a.has-submenu').off('click.wbshck').on('click.wbshck',function(e) {
                    if (touch || $(window).width() <= 1023) {
                        e && e.preventDefault();
                        $('.UIHeader .country .selected').removeClass('active');
                        $('.UIHeader .country .selector').removeClass('active');
                        if (!$(this).hasClass('active')) {
                            hideSubmenu();
                            showSubmenu($(this));
                        }
                        else {
                            hideSubmenu();
                        }
                    }
                });

                // show submenu
                $('.UIHeader .menu a').off('mouseenter.wbshck').on('mouseenter.wbshck',function(e) {
                    if (!touch && $(window).width() > 1023) {
                        if (!$(this).hasClass('active')) {
                            hideSubmenu();
                            showSubmenu($(this));
                        }
                        else {
                            hideSubmenu();
                        }
                    }
                });

                // hide submenu
                $('.UIHeader .submenu').off('mouseleave.wbshck').on('mouseleave.wbshck',function(e) {
                    if (!touch && $(window).width() > 1023) {
                        hideSubmenu();
                    }
                });

                // open mobile menu
                $('.UIHeader .btn-mobile').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    $('.UIHeader').toggleClass('active');
                    ($(window).width() <= 1023) ? $('.wbshck').addClass('noscroll') : $('.wbshck').removeClass('noscroll');
                });

                // close mobile menu
                $('.UIHeader .btn-close').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    $('.UIHeader').toggleClass('active');
                    $('.wbshck').removeClass('noscroll');
                });

                // resize: move submenu node to mobile menu and back
                $(window).resize(function() {

                    $('.wbshck').removeClass('noscroll');
                    $('.UIHeader, .UIHeader .submenu, .UIHeader .menu a').removeClass('active');
                    (moveSubmenuNodeTO) && (clearTimeout(moveSubmenuNodeTO));
                    moveSubmenuNodeTO = setTimeout(function() {

                        wwscr = document.body.clientWidth; // without scroller
                        wwscr = window.innerWidth; // with scrollbar

                        // console.log(wwscr);

                        if ($('.UIHeader .menu .submenu').length < 1 && wwscr <= 1023) {
                            $('.UIHeader .menu .has-submenu').after($('.UIHeader .submenu'));
                        }
                        if ($('.UIHeader .menu .submenu').length > 0 && wwscr > 1023) {
                            $('.UIHeader .btn-mobile').before($('.UIHeader .submenu'));
                        }
                    },300);
                }).trigger('resize');

            }

            function hideSubmenu() {
                // console.log('hideSubmenu');
                $('.UIHeader .submenu').removeClass('active');
                $('.UIHeader .menu a').removeClass('active');
            }

            function showSubmenu($btn) {
                // console.log('showSubmenu');
                var $submenu,
                    submenu_id = $btn.attr('href');

                if (submenu_id) {
                    $('.UIHeader .submenu').each(function() {
                        if ($(this).data('for') == submenu_id) {
                            $submenu=$(this);
                            $submenu.addClass('active');
                            $btn.addClass('active');
                        }
                    });

                }
            }

        }

        function homeController() {

            var ww = $(window).width(),
                wh = $(window).height(),
                articleW = 0, maxX = 0,
                coverIndex = 0, coverSliderInt = false,
                $collections = $('.UIHome .collection .slider');

            (function() {
                equalizeHeights();
                fixSliderWidth();
                resetSliderPosition();
                coverSliderInterval();
                preorderCountdown();
                events();
            }());

            function events() {

                // window resize
                $(window).on('resize',function(e) {
                    ww = $(window).width();
                    wh = $(window).height();
                    equalizeHeights();
                    fixSliderWidth();
                    resetSliderPosition();
                });

                // move slider prev/next
                $('.UIHome .collection .pager a').off('click.wbshck').on('click.wbshck', function(e) {
                    e && e.preventDefault();
                    moveSlider($(this));
                })

                // change cover slider
                $root.find('.keyvisual .prevnext a').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    var max = $root.find('.keyvisual .kv').length;
                    (coverSliderInt) && (clearInterval(coverSliderInt));
                    if ($(this).hasClass('next')) {
                        coverIndex++;
                        if (coverIndex >= max) coverIndex = 0;
                    }
                    else {
                        coverIndex--;
                        if (coverIndex < 0) coverIndex = max-1;
                    }
                    changeCoverSlide();

                });

                // change cover slider
                $root.find('.keyvisual .pager a').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();

                    (coverSliderInt) && (clearInterval(coverSliderInt));
                    var $this = $(this);
                    coverIndex = $root.find('.keyvisual .pager a').index($this);
                    changeCoverSlide();

                });

            }

            function preorderCountdown() {
                var $countDown = $root.find('.preorder .countdown'),
                    $days = $countDown.find('.days b'),
                    $hours = $countDown.find('.hours b'),
                    $minutes = $countDown.find('.minutes b'),
                    $seconds = $countDown.find('.seconds b'),
                    countDownDate = new Date($countDown.data('release-date'));

                // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
                // console.log(countDownDate);

                // Update the count down every 1 second
                var x = setInterval(function() {

                    // Get today's date and time
                    var now = new Date().getTime();

                    // Find the distance between now and the count down date
                    var distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        // console.log('EXPIRED');
                        $days.text(0);
                        $hours.text(0);
                        $minutes.text(0);
                        $seconds.text(0);
                    }
                    else {
                        // console.log(days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ');
                        $days.text(days);
                        $hours.text(hours);
                        $minutes.text(minutes);
                        $seconds.text(seconds);
                    }

                }, 1000);
            }

            function coverSliderInterval() {
                (coverSliderInt) && (clearInterval(coverSliderInt));
                coverSliderInt = setInterval(function() {
                    var max = $root.find('.keyvisual .kv').length;
                    coverIndex = coverIndex+1;
                    if (coverIndex >= max) coverIndex = 0;
                    // console.log(coverIndex, max);
                    changeCoverSlide();
                }, 7000);
            }

            function changeCoverSlide() {

                // clear
                $root.find('.keyvisual .pager a').removeClass('active');
                $root.find('.keyvisual .pager a:eq('+coverIndex+')').addClass('active');
                $root.find('.keyvisual .kv').removeClass('active');

                // show
                setTimeout(function() {
                    $root.find('.keyvisual .kv:eq('+coverIndex+')').addClass('active');
                },1200);

            }

            function moveSlider($btn) {

                var direction = $btn.hasClass('prev') ? 'prev' : 'next',
                    deltaX = direction=='next' ? -articleW : articleW;


                tw.to($collections,0.6,{x:'+='+deltaX, ease:Quint.easeOut, onUpdate:bounds});

                function bounds() {
                    // console.log(this.target[0]._gsTransform.x, -maxX);
                    (this.target[0]._gsTransform.x > 0) && (tw.to($collections,0.6,{x:0}));
                    (this.target[0]._gsTransform.x < -maxX) && (tw.to($collections,0.6,{x:-maxX}));
                }

            }

            function equalizeHeights() {

                $collections.width(20000);

                var $boxes=$('.UIHome .collection .article .info'),
                    mh=0;

                $boxes.css({'height':'auto'}).each(function() {
                    mh = Math.max(mh, $(this).height());
                }).height(mh);

                $('.UIHome .collection .holder, .UIHome .collection .slider').height($('.UIHome .collection .article:eq(0)').height());

            }

            function fixSliderWidth() {
                var $boxes = $('.UIHome .collection .slider .article'),
                    w = 0;

                $boxes.each(function() {
                    var element = $(this)[0];

                    var style = element.currentStyle || window.getComputedStyle(element),
                        width = element.offsetWidth,
                        margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);

                    articleW = width + margin;
                    w += articleW;

                });

                $('.UIHome .collection .slider').width(w);
                maxX = w - $('.UIHome .collection .holder').width() + 40;

            }

            function resetSliderPosition() {
                tw.set($collections,{x:0});
            }

        }

        function productController() {

            var gallery = {
                currIndex: 0,
                numOfGalleryImages: 0,
                images: []
            };

            (function() {
                formatMoney();
                preorderCountdown();
                compareSlickSlider();
                events();
            }());

            function events() {

                // show gallery
                $root.find('.UIProduct .extra-images .gallery .img, .UIProduct .features .gallery .img').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    openImageInLightboxGallery($(this));
                });

                // prev/next gallery
                $root.find('.lightbox .btn.pager').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    changeImageInLightboxGallery($(this));
                });

                // play video
                $root.find('.UIProduct .btn.play').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    openVideoPlayerInLightbox($(this));
                });

                // close lightbox
                $root.find('.lightbox .btn.close').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    closeLightbox();
                });

                // submenu
                $root.find('.UIProduct .nav a[href^="#"]').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    scrollToAnchor($(this).attr('href'));
                });

                // downloads filter
                $root.find('.UIProduct .downloads .filters a').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    filterDownloads($(this));
                });

                $(window).on('resize.safetyinfo',function() {
                    var $safety = $root.find('.UIProduct .safety-info'),
                        $mobileCol = $root.find('.UIProduct .safety-info-mobile .col.info');
                    if ($safety.length < 1 || $mobileCol.length < 1) {
                        return;
                    }
                    if (window.innerWidth <= 600 && $mobileCol.has($safety).length < 1) {
                        $mobileCol.append($safety);
                    }
                    if (window.innerWidth > 600 && $mobileCol.has($safety).length > 0) {
                        $root.find('.UIProduct .features').not('.safety-info-mobile').find('.col.info').append($safety);
                    }
                }).trigger('resize.safetyinfo');

                $root.find('a.compare').off('click.wbshck').on('click.wbshck',function(e) {
                  e && e.preventDefault();

                    $('body').addClass('compare-modal-opened');
                    $('.compare-modal').show();
                    // $('.variants-list').slick('unslick');

                    $('.variants-list').slick('refresh');
                    $('.compare-list-content:not(.included-gameplay-content)').equalHeights();
                    $('.compare-price').equalHeights();

                    
                    let hasIncludedGameplayContent = false;
                    $('.included-gameplay-content').each(function() {
                      if ($.trim($(this).text())) {
                        hasIncludedGameplayContent = true;
                        return false; // break the loop
                      }
                    });

                    if (!hasIncludedGameplayContent) {
                      $('.included-gameplay-content').hide();
                      $('.included-gameplay-title').hide();
                    } else {
                      $('.included-gameplay-content').equalHeights();
                    }


                    let compareTitlePricing = $('.variants-list .compare-title-pricing');
                    if(compareTitlePricing.length) {
                      let compareTitlePricingPosition = $('.variants-list .compare-title-pricing').position();
                      let topPos = compareTitlePricingPosition.top;

                      if($(window).width() >= 1400) {
                        topPos += 160;
                      } else if($(window).width() >= 801) {
                        topPos += 510;
                      } else if($(window).width() >= 520) {
                        topPos += 377 + $('.compare-modal-wrap h2').height();
                      } else {
                          topPos += 110 +
                            $('.compare-modal-wrap h2').height() + 
                            $('.variant-item > a > figure').height() + 
                            $('.variant-item > h3').height() + 
                            $('.variant-item > .btn.button.close-compare').height() +
                            $('.variant-item > p').height()
                      }
                      
                      if( $('.new-compare-title-pricing').length === 0 ) {
                        $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-title-pricing"><h4>Pricing</h4></div>');
                      }
                      $('.new-compare-title-pricing').css('top', topPos + 'px')
                    }

                    let compareTitleComDiff = $('.variants-list .compare-title-component-differences');
                    if(compareTitleComDiff.length) {
                      if( $(compareTitleComDiff[0]).css("display") !== "none" ) {
                        let compareTitleComDiffPosition = $('.variants-list .compare-title-component-differences').position();
                        let topPos = compareTitleComDiffPosition.top;
  
                        if($(window).width() >= 1400) {
                          topPos += 160;
                        } else if($(window).width() >= 801) {
                          topPos += 510;
                        } else if($(window).width() >= 520) {
                          topPos += 377 + $('.compare-modal-wrap h2').height();
                        } else {
                          topPos += 110 +
                            $('.compare-modal-wrap h2').height() + 
                            $('.variant-item > a > figure').height() + 
                            $('.variant-item > h3').height() + 
                            $('.variant-item > .btn.button.close-compare').height() +
                            $('.variant-item > p').height()
                        }
  
                        if( $('.new-compare-title-component-differences').length === 0 ) {
                          $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-title-component-differences"><h4>Component Differences</h4></div>');
                        }
                        $('.new-compare-title-component-differences').css('top', topPos + 'px')
                      }
                    }
                  

                    let compareTitleIncGameplay = $('.variants-list .included-gameplay-title');
                    if(compareTitleIncGameplay.length) {
                      if( $(compareTitleIncGameplay[0]).css("display") !== "none" ) {
                        let compareTitleIncGameplayPosition = $('.variants-list .included-gameplay-title').position();
                        let topPos = compareTitleIncGameplayPosition.top;

                        if($(window).width() >= 1400) {
                          topPos += 160;
                        } else if($(window).width() >= 801) {
                          topPos += 510;
                        } else if($(window).width() >= 520) {
                          topPos += 377 + $('.compare-modal-wrap h2').height();
                        } else {
                          topPos += 110 +
                            $('.compare-modal-wrap h2').height() + 
                            $('.variant-item > a > figure').height() + 
                            $('.variant-item > h3').height() + 
                            $('.variant-item > .btn.button.close-compare').height() +
                            $('.variant-item > p').height()
                          
                            setTimeout(function() {
                              $(window).trigger('resize');
                            }, 50);
                        }
  
                        if( $('.new-compare-included-gameplay-title').length === 0 ) {
                          $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-included-gameplay-title"><h4>Included Gameplay Content</h4></div>');
                        }
                        $('.new-compare-included-gameplay-title').css('top', topPos + 'px')
                      }
                    }

                });

                $root.find('.compare-modal .close-btn, .close-compare').off('click.wbshck').on('click.wbshck',function(e) {
                  e && e.preventDefault();
                  $('body').removeClass('compare-modal-opened');
                  $('.compare-modal').hide();
                });


                $.fn.equalHeights = function() {
                    var maxHeight = 0,
                        $this = $(this);

                    $this.each( function() {
                        var height = $(this).innerHeight();

                        if ( height > maxHeight ) { maxHeight = height; }
                    });

                    return $this.css('height', maxHeight);
                };

                // auto-initialize plugin
                $('[data-equal]').each(function(){
                    var $this = $(this),
                        target = $this.data('equal');
                    $this.find(target).equalHeights();
                });




                function insertURLParam(key, value) {
                  key = encodeURIComponent(key);
                  value = encodeURIComponent(value);

                  // kvp looks like ['key1=value1', 'key2=value2', ...]
                  var kvp = document.location.search.substr(1).split('&');
                  let i=0;

                  for(; i<kvp.length; i++){
                      if (kvp[i].startsWith(key + '=')) {
                          let pair = kvp[i].split('=');
                          pair[1] = value;
                          kvp[i] = pair.join('=');
                          break;
                      }
                  }

                  if(i >= kvp.length){
                      kvp[kvp.length] = [key,value].join('=');
                  }

                  // can return this or...
                  let params = kvp.join('&');

                  // reload page with new params
                  document.location.search = params;
                }

                // variant select
                $root.find('.UIProduct #productSelect').off('change.wbshck').on('change.wbshck',function(e) {
                  if($root.find('.UIProduct').hasClass('v2')) {
                    insertURLParam('variant', this.value)
                  } else {
                    $root.find('.UIProduct .features .sku, .UIProduct .keyvisual h3').removeClass('active');
                    $root.find('.UIProduct .features .sku[data-id="'+ $(this).val() +'"], .UIProduct .keyvisual h3[data-id="'+ $(this).val() +'"]').addClass('active');
                  }
                });

                $root.find('.UIProduct button[name="add"]').off('click.wbshck').on('click.wbshck',function(e) {
                    if (
                        $(this).data('preorder')==1 &&
                        !confirm('This is a pre-order. We will charge you for a product, but it will be delivered when available.')
                    ) {
                        e && e.preventDefault();
                    }
                });

            }

            function filterDownloads($filter) {
                $root.find('.UIProduct .downloads .filters a').removeClass('active');
                $filter.addClass('active');
                $root.find('.UIProduct .downloads .links a').removeClass('last').hide();
                if ($filter.data('tag')=='all') {
                    $root.find('.UIProduct .downloads .links a').removeClass('last').show();
                }
                else if ($filter.data('tag')=='latest') {
                    $root.find('.UIProduct .downloads .links a').slice(0,4).show().last().addClass('last');
                }
                else {
                    $root.find('.UIProduct .downloads .links a').hide().each(function() {
                        ($(this).data('tags') && $(this).data('tags').indexOf($filter.data('tag'))!=-1) && $(this).show();
                    });
                    $root.find('.UIProduct .downloads .links a:visible').last().addClass('last');
                }
            }

            function closeLightbox() {
                $root.find('.lightbox').remove();
            }

            function changeImageInLightboxGallery($btn) {

                var $lightbox = $root.find('.lightbox.gallery'),
                    direction = $btn.hasClass('next') ? 'next' : 'prev';


                if ($lightbox.length < 1) return;


                if (direction == 'next') {
                    gallery.currIndex ++;
                    if (gallery.currIndex >= gallery.numOfGalleryImages) gallery.currIndex = 0;
                }
                else {
                    gallery.currIndex --;
                    if (gallery.currIndex < 0) gallery.currIndex = gallery.numOfGalleryImages-1;
                }
                // console.log(direction, gallery.numOfGalleryImages, gallery.currIndex);

                $lightbox.find('.image img').attr('src',gallery.images[gallery.currIndex].src);
                $lightbox.find('.label .currIndex').text(gallery.currIndex+1);

            }

            function openImageInLightboxGallery($btn) {

                var url = $btn.data('src'),
                    numOfGalleryImages = $btn.closest('.gallery').data('gallery_num'),
                    currIndex = parseInt($btn.data('index'),10)-1,
                    $lightbox = $(''+
                        '<div class="lightbox gallery">'+
                            '<a class="btn close"><i></i><i></i></a>'+
                            '<a class="btn pager prev"><i></i><i></i></a>'+
                            '<a class="btn pager next"><i></i><i></i></a>'+
                            '<div class="image"></div>'+
                            '<div class="label"><b class="currIndex">'+(currIndex+1)+'</b>/<b class="numOfGalleryImages">'+numOfGalleryImages+'</b></div>'+
                        '</div>'+
                    ''),
                    tempImages=[];

                gallery.numOfGalleryImages = numOfGalleryImages;
                gallery.currIndex = currIndex;

                $root.find('.UIProduct .gallery .img').each(function() {
                    if ($(this).data('index') && $(this).data('src')) {
                        tempImages.push({
                            src: $(this).data('src'),
                            index: parseInt($(this).data('index'),10)-1
                        })
                    }
                })
                gallery.images = tempImages;

                function propComparator(prop) {
                    return function(a, b) {
                        return a[prop] - b[prop];
                    }
                }

                gallery.images.sort(propComparator('index'));
                // console.log(gallery);

                $root.append($lightbox);
                $lightbox.find('.image').append('<img src="'+url+'">')
                events();
            }

            function openVideoPlayerInLightbox($btn) {
                  var url = $btn.data('src'),
                      $lightbox = $(''+
                          '<div class="lightbox video">'+
                              '<a class="btn close"><i></i><i></i></a>'+
                              '<div class="youtube"></div>'+
                          '</div>'+
                      '');

                  $root.append($lightbox);
                  $lightbox.find('.youtube').append('<iframe width="560" height="315" src="//www.youtube.com/embed/'+getYoutubeIdFromUrl(url)+'?autoplay=1&related=0" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>')
                  events();
            }

            function preorderCountdown() {
                var $countDown = $root.find('.preorder .countdown'),
                    $days = $countDown.find('.days b'),
                    $hours = $countDown.find('.hours b'),
                    $minutes = $countDown.find('.minutes b'),
                    $seconds = $countDown.find('.seconds b'),
                    countDownDate = new Date($countDown.data('release-date'));

                // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
                // console.log(countDownDate);

                // Update the count down every 1 second
                var x = setInterval(function() {

                    // Get today's date and time
                    var now = new Date().getTime();

                    // Find the distance between now and the count down date
                    var distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        // console.log('EXPIRED');
                        $days.text(0);
                        $hours.text(0);
                        $minutes.text(0);
                        $seconds.text(0);
                    }
                    else {
                        // console.log(days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ');
                        $days.text(days);
                        $hours.text(hours);
                        $minutes.text(minutes);
                        $seconds.text(seconds);
                    }

                }, 1000);
            }

            function formatMoney() {
                var $prices = $('.UIProduct .sku i'),
                    $options = $('.UIProduct #productSelect option'),
                    currencyCode = $('.UIHeader .currency').data('currency')

                $prices.each(function() {
                    var $price = $(this),
                        priceInCents = $price.data('price'),
                        currencySymbol = $price.data('currency'),
                        priceFormattedAndRounded = 0;

                    if (priceInCents) {
                        priceFormattedAndRounded = Math.round(priceInCents / 100);
                        // console.log(priceInCents,priceFormattedAndRounded);
                        $price.html(currencySymbol+''+priceFormattedAndRounded+' <u>'+ currencyCode +'</u>');
                    }

                });

                $options.each(function() {
                    var $option = $(this),
                        priceInCents = $option.data('price'),
                        currencySymbol = $option.data('currency'),
                        variantTitle = $option.data('variant-title'),
                        priceFormattedAndRounded = 0;

                    if (priceInCents) {
                        priceFormattedAndRounded = Math.round(priceInCents / 100);
                        // console.log(priceInCents,priceFormattedAndRounded);
                        // $option.text(variantTitle+' - '+currencySymbol+''+priceFormattedAndRounded+' '+ currencyCode +'');
                    }

                });

            }

            function compareSlickSlider() {
                console.log('compare')
                if($('.variants-list').length > 0) {
                  $('.variants-list').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    responsive: [
                        {
                          breakpoint: 1400,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                          }
                        },
                        {
                          breakpoint: 900,
                          settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                        }
                    ]
                  });
                }
            }

        }

        function collectionController() {

            (function() {
                input();
                formatMoney();
                buildTagsFilters();
                events();
                explodeKeyvisualH2Letters();
                hideEmptyCategories();
            }());

            function events() {

                // select click default
                $root.find('.filters .btn.down').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                });

                // filter
                $root.find('.filters select[name="tags"]').off('change.wbshck').on('change.wbshck',function(e) {
                    filterProductsByTag();
                });

                // sort
                $root.find('.filters select[name="sort"]').off('change.wbshck').on('change.wbshck',function(e) {
                    sortProducts($(this));
                });

            }

            function input() {
                var qp = getQueryParams(window.location.search),
                    sortBy = qp.sort_by; // $root.find('.filters select[name="sort"]').data('value');
                // console.log(sortBy);
                if (sortBy) {
                    $root.find('.filters select[name="sort"]').val(sortBy);
                    (sortBy.indexOf('released')!=-1) && (sortByReleased(sortBy));
                }
            }

            function sortByReleased(sortBy) {
                // console.log('sortByReleased',sortBy);
                if (sortBy=='released-ascending') {
                    $('.grid .product').sort(function(a,b) {
                        var av = parseInt($(a).data('released'),10) || 0,
                            bv = parseInt($(b).data('released'),10) || 0;
                        // console.log(av,bv);
                        return av - bv;
                    }).appendTo('.grid');
                }
                else {
                    $('.grid .product').sort(function(a,b) {
                        var av = parseInt($(a).data('released'),10) || 0,
                            bv = parseInt($(b).data('released'),10) || 0;
                        // console.log(av,bv);
                        return bv - av;
                    }).appendTo('.grid');
                }
            }

            function sortProducts($this) {
                // console.log('sortProducts');
                Shopify.queryParams = {};
                if (location.search.length) {
                    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                        aKeyValue = aCouples[i].split('=');
                        if (aKeyValue.length > 1) {
                            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                        }
                    }
                }
                Shopify.queryParams.sort_by = $this.val();
                location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
            }

            function filterProductsByTag() {
                // console.log('filterProductsByTag');

                var tag = $root.find('.filters select[name="tags"]').val();

                $root.find('.products').show();
                $root.find('.product').show();
                if (tag!='all') {
                    $root.find('.product').hide();
                    $root.find('.product').each(function() {
                        var tags = $(this).data('tags');
                        if (tags && tags.indexOf(tag) != -1) {
                            $(this).show();
                        }
                    });
                    // check if no products in group - hide group
                    $root.find('.products').each(function() {
                        if ($(this).find('.product:visible').length < 1) $(this).hide();
                    })
                }

            }

            function buildTagsFilters() {
                var $products = $root.find('.products .product'),
                    $tags_filter = $root.find('.filters select[name="tags"]'),
                    all_tags = [];

                // prepare tags
                $products.each(function() {
                    var tags = $(this).data('tags');
                    if (tags && tags.indexOf(', ')!=-1) {
                        all_tags = _.union(all_tags, tags.split(', '));
                    }
                    if (tags && tags.indexOf(', ')==-1) {
                        if (all_tags.indexOf(tags) === -1) {
                          all_tags.push(tags);
                        }
                    }
                });
                all_tags.sort();

                // render tags options
                _.each(all_tags,function(tag) {
                    // console.log(tag);
                    var $option = $('<option></option>');
                    $option.text(tag);
                    $option.attr('value',tag);
                    $tags_filter.append($option);
                });

            }

            function explodeKeyvisualH2Letters() {
                var words = $('.UICollection .keyvisual .filters h2').text().split('');
                $('.UICollection .keyvisual .filters h2').empty();
                $.each(words, function(i, v) {
                    if (v===' ') {
                        $('.UICollection .keyvisual .filters h2').append('<span>&nbsp;</span>');
                    }
                    else {
                        $('.UICollection .keyvisual .filters h2').append($('<span>').text(v));
                    }
                });
            }

            function formatMoney() {
                var $prices = $('.UICollection .product h6 b'),
                    currencyCode = $('.UIHeader .currency').data('currency');

                $prices.each(function() {
                    var $price = $(this),
                        priceInCents = $price.data('price'),
                        priceFormattedAndRounded = 0;

                    if (priceInCents) {
                        priceFormattedAndRounded = Math.round(priceInCents / 100);
                        // console.log(priceInCents,priceFormattedAndRounded);
                        $price.html(priceFormattedAndRounded +' <sup>'+ currencyCode+'</sup>');
                    }

                });

            }

            function hideEmptyCategories() {

                $('.UICollection.all .products').each(function() {
                    if ($(this).find('.product').length==0) {
                        $(this).hide();
                    }
                });

                $('.UICollection .products').each(function() {
                    if ($(this).find('.product').length==0) {
                        $(this).find('.empty').show();
                        $(this).find('.head').hide();
                    }
                });

            }

        }

        function addressesController() {

            // init
            (function() {
                input();
                events();
            }());

            function input() {
                var $countrySelectors = $root.find('.address-item select[name="address[country]"]');

                $countrySelectors.each(function() {
                    var $country = $(this),
                        $group = $country.closest('.group'),
                        $province = $country.siblings('select[name="address[province]"]'),
                        country = $group.data('country'),
                        province = $group.data('province');

                    $country.find('option[value="'+ country +'"]').prop('selected','selected');

                    if (province && $province.length < 1) {
                        renderProvinces($country.find('option[value="'+ country +'"]'));
                        $province = $country.siblings('select[name="address[province]"]');
                    }
                    $province.find('option[value="'+ province +'"]').prop('selected','selected');

                })
            }

            function events() {

                // show provinces on country select
                $root.find('select[name="address[country]"]').off('change').on('change',function(e) {
                    var $selectedOption = $(this).find('option:eq('+$(this)[0].selectedIndex+')');
                    renderProvinces($selectedOption);
                });

                // default address
                $root.find('.btn.default').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    makeDefaultAddressandSave($(this).closest('.address-item'));
                })

            }

            function makeDefaultAddressandSave($address) {
                var addressId = $address.data('address_id'),
                    defaultAddressId = $address.data('default_address_id'),
                    $form = $address.find('form');

                // console.log($form, defaultAddressId, addressId);

                $form.attr('action','/account/addresses/'+defaultAddressId);
                $form.attr('id','address_form_'+defaultAddressId);
                $form[0].submit();
            }

            function renderProvinces($option) {
                var provinces = $option.data('provinces'),
                    $provinces = $('<select name="address[province]"></select>');

                $option.closest('.group').find('select[name="address[province]"]').remove();
                if (!provinces || provinces.length < 1) return;

                $provinces.append('<option disabled selected>Province</option>')
                for (var i=0; i < provinces.length; i++) {
                    $provinces.append('<option value="'+ provinces[i][0] +'">'+ provinces[i][0] +'</option>')
                }
                $option.closest('select').after($provinces)
            }

        }

        function accountController() {

            // init
            (function() {
                // console.log('accountController');
                inputs();
                events();
                scrollToErrorMsg();
            }());

            function inputs() {

                // show recover password form
                console.log(window.location.hash);
                if (window.location.hash=='#recover') {
                    showRecoverPasswordForm();
                }

            }

            function events() {

                // show recover password form
                $root.find('.forgot a').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    showRecoverPasswordForm();
                });

                // edit address
                $root.find('.btn.new').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    var $form = $(this).closest('.col.new').find('.edit-form');
                    $form.show();
                    $(this).hide();
                });

                // edit address
                $root.find('.btn.edit').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    var $form = $(this).closest('.address-item').find('.edit-form');
                    var $details = $(this).closest('.address-item').find('.details');
                    $details.hide();
                    $form.show();
                });

                // cancel edit address
                $root.find('.btn.cancel').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    var $form = $(this).closest('.address-item, .col.new').find('.edit-form');
                    var $details = $(this).closest('.address-item').find('.details');
                    var $btnnew = $(this).closest('.col.new').find('.btn.new');
                    $details.show();
                    $btnnew.show();
                    $form.hide();
                });

                // delete address
                $root.find('.btn.delete').off('click').on('click',function(e) {
                    // console.log('delete..');
                    if (!confirm('Are you sure you want to delete this address?')) {
                        e && e.preventDefault();
                    }
                });

                // save address
                $root.find('.btn.save').off('click').on('click',function(e) {
                    // e && e.preventDefault();
                    // console.log('save..');
                });

            }

            function showRecoverPasswordForm() {
                $root.find('.signin').hide();
                $root.find('.recover').show();
            }

            function scrollToErrorMsg() {
                if ($root.find('form .errors').length > 0) {
                    console.log('scrollToErrorMsg');
                    $('html, body').animate({
                        scrollTop: $root.find('form .errors:eq(0)').offset().top - 100
                    }, 500);
                }
            }

        }

        function contactController() {

            (function() {
                events();
            }())

            function events() {

                // disable dev links
                $root.find('.info a[href="/"]').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                });

            }

        }

        function cartController() {

            (function() {
                events();
            }());

            function events() {
                $('.UICart .qty .icon').off('click.wbshck').on('click.wbshck',function(e) {
                    e && e.preventDefault();
                    increaseCartItemQuantity($(this));
                });
            }

            function increaseCartItemQuantity($btn) {

                var $qty = $btn.closest('.qty').find('input.quantity'),
                    qty = ($qty.val()) ? parseInt($qty.val(),10) : 0,
                    min = 1;


                if ($btn.hasClass('up')) {
                    qty++;
                    $qty.val(qty);
                    // console.log('up',qty);
                }
                else {
                    qty--;
                    if (qty < min) qty=min;
                    $qty.val(qty);
                    // console.log('down',qty);
                }

                // update form
                $('.UICart .cart button[name="update"]').trigger('click');

            }


        }


        // helpers
        function getYoutubeIdFromUrl(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            var match = url.match(regExp);

            return (match && match[2].length === 11) ? match[2] : null;
        }

        function isTouchDevice() {
            var touch = false;
            try {
                // is touch device
                document.createEvent('TouchEvent');
                $('html, body').removeClass('no-touch');
                touch = true;
            }
            catch (e) {
                // is not touch  device
                $('html, body').addClass('no-touch');
                touch = false;
            }
            return touch;
        }

        function scrollToAnchor(aid) {
            var aTag = $('a[name="'+ aid.replace('#','') +'"]');
            if( aTag.length && !$('body.page\\.game-info').length ) {
              console.log('scroll v1')
              $('html, body').animate({scrollTop: aTag.offset().top - 80},500);
            }
        }

        function getQueryParams(qs) {
            qs = qs.split('+').join(' ');

            var params = {},
                tokens,
                re = /[?&]?([^=]+)=([^&]*)/g;

            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            }

            return params;
        }

    }());

});


// run on document ready
$(document).ready(function() {
    WbshckWeb($,_,TweenMax);
    // $("#productSelect").on("click", function(el){
    //     console.log()
    //     var current_var_id  = $(this).val()
    //     if(current_var_id != '' && current_var_id != undefined ){
    //       var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + current_var_id;
    //       window.location.href = newurl
    //       window.history.replaceState({path: newurl}, '', newurl);
    //     }
    // })


  $(window).resize(function() {
    if( $('.compare-modal').css("display") !== "none" ) {
      
      let maxHeight = 90;
      // Iterate over each element to find the highest height

      /*
      $('.variant-item > h3').each(function() {
        var thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
      });
      */
      
      // Set each element's height to the maximum height
      $('.variant-item > h3').height(maxHeight);


      
      let compareTitlePricing = $('.variants-list .compare-title-pricing');
      if(compareTitlePricing.length) {
        let compareTitlePricingPosition = $('.variants-list .compare-title-pricing').position();
        let topPos = compareTitlePricingPosition.top;
        console.log(compareTitlePricingPosition);
  
        if($(window).width() >= 1400) {
          topPos += 160;
        } else if($(window).width() >= 801) {
          topPos += 160;
        } else {
          topPos += 27 + $('.compare-modal-wrap h2').height();
        }
        
        if( $('.new-compare-title-pricing').length === 0 ) {
          $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-title-pricing"><h4>Pricing</h4></div>');
        }
        $('.new-compare-title-pricing').css('top', topPos + 'px')
      }
  
      let compareTitleComDiff = $('.variants-list .compare-title-component-differences');
      if(compareTitleComDiff.length) {
        if( $(compareTitleComDiff[0]).css("display") !== "none" ) {
          let compareTitleComDiffPosition = $('.variants-list .compare-title-component-differences').position();
          let topPos = compareTitleComDiffPosition.top;
  
          if($(window).width() >= 1400) {
            topPos += 160;
          } else if($(window).width() >= 801) {
            topPos += 160;
          } else {
            topPos += 27 + $('.compare-modal-wrap h2').height();
          }
  
          if( $('.new-compare-title-component-differences').length === 0 ) {
            $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-title-component-differences"><h4>Component Differences</h4></div>');
          }
          $('.new-compare-title-component-differences').css('top', topPos + 'px')
        }
      }
    
  
      let compareTitleIncGameplay = $('.variants-list .included-gameplay-title');
      if(compareTitleIncGameplay.length) {
        if( $(compareTitleIncGameplay[0]).css("display") !== "none" ) {
          let compareTitleIncGameplayPosition = $('.variants-list .included-gameplay-title').position();
          let topPos = compareTitleIncGameplayPosition.top;
  
          if($(window).width() >= 1400) {
            topPos += 160;
          } else if($(window).width() >= 801) {
            topPos += 160;
          } else {
            topPos += 27 + $('.compare-modal-wrap h2').height();
          }
  
          if( $('.new-compare-included-gameplay-title').length === 0 ) {
            $('.compare-modal-content-wrap').append('<div class="new-compare-title new-compare-included-gameplay-title"><h4>Included Gameplay Content</h4></div>');
          }
          $('.new-compare-included-gameplay-title').css('top', topPos + 'px')
        }
      }
    }

    

    
  });

  
});
